// extracted by mini-css-extract-plugin
export default {"colorPalette":"ColorPalette_colorPalette__R-ezj"};